
export function authHeader() {
    return {};
}
